
import { Component, Prop, Vue, } from 'vue-property-decorator';

@Component
export default class LandingLink extends Vue {
	@Prop({
		type: String,
		required: true,
	})
	content!: string;

	@Prop({
		type: String,
		required: false,
		default: 'anchor',
	})
	linkType?: 'anchor' | 'router';

	get linkComponentType() {
		if (this.linkType === 'router') {
			return 'router-link';
		}
		return 'a';
	}
}
